<template>
    <div class="root d-inline-block">
        <router-link class="btn btn-success" :to="'/user-accesses/' + row.id">دسترسی ها</router-link>
    </div>
</template>

<script>
    export default {
        name: "user-accesses-button-link",
        props: ["row"]
    };
</script>

<style scoped>

</style>